var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesFillNotification = function SvgResourcesFillNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    fillRule: "evenodd",
    d: "M31.062 36H12.024c-.924.024-2.024.39-2.024 2s1.1 1.976 2.024 2h19.557a8.03 8.03 0 0 0 3.543 4H12c-2.412 0-6-1.598-6-6V10c0-4.402 3.588-6 6-6h26a4 4 0 0 1 4 4v21.582A8.001 8.001 0 0 0 31.062 36M34 12H16v4h18z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 37,
    r: 5,
    fill: "#EDBE62"
  })));
};
export { SvgResourcesFillNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS4wNjE5IDM2SDEyLjAyNEMxMS4xIDM2LjAyNCAxMCAzNi4zOSAxMCAzOEMxMCAzOS42MSAxMS4xIDM5Ljk3NiAxMi4wMjQgNDBIMzEuNTgxNUMzMi4yNzEyIDQxLjcwMzggMzMuNTMwOCA0My4xMTYgMzUuMTI0IDQ0SDEyQzkuNTg4IDQ0IDYgNDIuNDAyIDYgMzhWMTBDNiA1LjU5OCA5LjU4OCA0IDEyIDRIMzhDMzkuMDYwOSA0IDQwLjA3ODMgNC40MjE0MyA0MC44Mjg0IDUuMTcxNTdDNDEuNTc4NiA1LjkyMTcyIDQyIDYuOTM5MTMgNDIgOFYyOS41ODE1QzQxLjA3MzYgMjkuMjA2NSA0MC4wNjA5IDI5IDM5IDI5QzM0LjkyMDQgMjkgMzEuNTU0IDMyLjA1MzcgMzEuMDYxOSAzNlpNMzQgMTJIMTZWMTZIMzRWMTJaIiBmaWxsPSIjMjgzRTRDIi8+CjxjaXJjbGUgY3g9IjM5IiBjeT0iMzciIHI9IjUiIGZpbGw9IiNFREJFNjIiLz4KPC9zdmc+Cg==";